import styled from "vue-styled-components";

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-block: 3rem;
    text-align: center;
    max-width: 800px;
    margin-inline: auto;

    h1 {
        color: #fefefe;
        font-size: 2.8rem;
    }

    h2 {
        color: ${props => props.theme?.text_site_color ?? "#4a505e"};
        margin-bottom: 0.5rem;
        font-weight: 400;
        font-size: 1.8rem;
    }

    p {
        color: ${props => props.theme?.text_site_color ?? "#4a505e"};
        font-size: 1.4rem;
    }

    img {
        width: 100%;
        max-width: 500px;
        height: 100%;
        max-height: 400px;
        object-fit: contain;
        cursor: pointer;
    }

    .percentage-hits {
        position: relative;
        margin-block: 2rem;
        span {
            position: absolute;
            right: 0;
            top: -1.2rem;
        }
        progress {
            background: ${props => props.theme?.border_color_site ?? '#e9ecef'};
            max-width: 15rem;
            height: 0.9rem;
            width: 100%;
            border-radius: 0.5rem;

            &::-moz-progress-bar {
                background: ${props => props.theme?.titles_site_color ?? "#2b2b2d"};
                border-radius: 0.5rem;
            }
        }
    }
`;
